<template>
  <div class="gmap" ref="gmap"></div>
</template>

<script lang="ts">
import loadGoogleMapsApi from 'load-google-maps-api'
import { Vue, Component, Prop } from 'vue-property-decorator'

import settings from '../settings'

@Component
export default class GMap extends Vue {
  @Prop({ default: { lat: 0, lng: 0 } }) center: google.maps.LatLng
  @Prop({ default: 7 }) zoom: number

  private map: google.maps.Map

  async mounted() {
    try {
      let client = await loadGoogleMapsApi({
        //key: 'AIzaSyCPOQy9j0sxxC1cLmc1YXSLLlcBvmZp_ZU',
        key: settings.gmapKey,
      })
      this.map = new client.Map(<Element>this.$refs.gmap, {
        center: this.center,
        zoom: this.zoom,
      })
      let self = this
      this.map.addListener('click', function () {
        self.$emit('change', self.map)
      })

      new Promise(function (resolve, reject) {
        navigator.geolocation.getCurrentPosition(
          function (position) {
            self.map.setCenter(
              new google.maps.LatLng(
                position.coords.latitude,
                position.coords.longitude
              )
            )
            resolve(true)
          },
          function (error) {
            reject(false)
          }
        )
      }).finally(function () {
        self.map.addListener('center_changed', function () {
          self.$emit('change', self.map)
        })
      })
    } catch (error) {
      //console.log(error)
    }
  }

  public getMap(): google.maps.Map {
    return this.map
  }

  public geoLocalizar(): void {
    let self = this
    navigator.geolocation.getCurrentPosition(
      function (position) {
        self.map.setCenter(
          new google.maps.LatLng(
            position.coords.latitude,
            position.coords.longitude
          )
        )
      },
      function (error) {}
    )
  }
}
</script>>

<style scoped>
.gmap::v-deep > div::after {
  width: 32px;
  height: 32px;
  display: block;
  content: ' ';
  position: absolute;
  top: 50%;
  left: 50%;
  margin: -40px 0 0 -11px;
  /*background: url('https://maps.gstatic.com/mapfiles/api-3/images/spotlight-poi_hdpi.png');*/
  background: url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/PjxzdmcgaGVpZ2h0PSIyNCIgdmVyc2lvbj0iMS4xIiB3aWR0aD0iMjQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6Y2M9Imh0dHA6Ly9jcmVhdGl2ZWNvbW1vbnMub3JnL25zIyIgeG1sbnM6ZGM9Imh0dHA6Ly9wdXJsLm9yZy9kYy9lbGVtZW50cy8xLjEvIiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiPjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgLTEwMjguNCkiPjxwYXRoIGQ9Im0xMiAwYy00LjQxODMgMi4zNjg1ZS0xNSAtOCAzLjU4MTctOCA4IDAgMS40MjEgMC4zODE2IDIuNzUgMS4wMzEyIDMuOTA2IDAuMTA3OSAwLjE5MiAwLjIyMSAwLjM4MSAwLjM0MzggMC41NjNsNi42MjUgMTEuNTMxIDYuNjI1LTExLjUzMWMwLjEwMi0wLjE1MSAwLjE5LTAuMzExIDAuMjgxLTAuNDY5bDAuMDYzLTAuMDk0YzAuNjQ5LTEuMTU2IDEuMDMxLTIuNDg1IDEuMDMxLTMuOTA2IDAtNC40MTgzLTMuNTgyLTgtOC04em0wIDRjMi4yMDkgMCA0IDEuNzkwOSA0IDQgMCAyLjIwOS0xLjc5MSA0LTQgNC0yLjIwOTEgMC00LTEuNzkxLTQtNCAwLTIuMjA5MSAxLjc5MDktNCA0LTR6IiBmaWxsPSIjZTc0YzNjIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIDEwMjguNCkiLz48cGF0aCBkPSJtMTIgM2MtMi43NjE0IDAtNSAyLjIzODYtNSA1IDAgMi43NjEgMi4yMzg2IDUgNSA1IDIuNzYxIDAgNS0yLjIzOSA1LTUgMC0yLjc2MTQtMi4yMzktNS01LTV6bTAgMmMxLjY1NyAwIDMgMS4zNDMxIDMgM3MtMS4zNDMgMy0zIDMtMy0xLjM0MzEtMy0zIDEuMzQzLTMgMy0zeiIgZmlsbD0iI2MwMzkyYiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAxMDI4LjQpIi8+PC9nPjwvc3ZnPg==');
  /*background: url('data:image/svg+xml;utf-8,<svg width="32" height="32" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><path fill="red" stroke="white" stroke-width="1.5" d="M3.5 3.5h25v25h-25z"></path></svg>');*/
  background-size: 32px 32px; /* Since I used the HiDPI marker version this compensates for the 2x size */
  pointer-events: none; /* This disables clicks on the marker. Not fully supported by all major browsers, though */
}
</style>